import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.css']
})
export class LoginHeaderComponent implements OnInit {

  public logo: string = environment.logo;
  public state: string = environment.state;
  currentRoute = 'dashboard';
  constructor(private router: Router) { }

  ngOnInit() {
    this.currentRoute = this.router.url.replace('/', '');
  }

}
